import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DurationProductPriceInfoService} from 'app/blocks/service/api/duration-product-price-info.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IDurationProductPriceInfo} from 'app/blocks/model/duration-product-price-info.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {DurationProductPriceInfo} from 'app/blocks/model/duration-product-price-info.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class DurationProductPriceInfoResource extends AbstractEntityResource<IDurationProductPriceInfo> {
    constructor(durationProductPriceInfoService: DurationProductPriceInfoService, router: Router) {
        super(
            Resource.DURATION_PRODUCT_PRICE_INFOS,
            durationProductPriceInfoService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.DURATION_PRODUCT_PRICE_INFOS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.DURATION_PRODUCT_PRICE_INFOS),
            (entity?) => new DurationProductPriceInfo(entity),
            (entity) => entity.code
        );
    }
}
